import { Center, Text } from "@chakra-ui/react";
import { Filler } from "components/filler/Filler";
import { Button } from "components/button/Button";
import {
  getPreviewGatewayPr,
  continueWithLiveGateway,
} from "api/devtools/previewGatewayPath";

export const PreviewGatewayUnreachable = () => {
  const pr = getPreviewGatewayPr();

  return (
    <Center minH="100vh" flexDirection="column" textAlign="center">
      <Filler.SVGFiller
        imagePath="error/Triangle"
        variant="other"
        headline={`Preview ${pr} isn't reachable`}
        mb="4"
        mt="0"
      >
        <Text>
          It may have been torn down, or the branch was merged or closed.
        </Text>
        <Button variant="primary" onClick={continueWithLiveGateway}>
          Continue with live gateway
        </Button>
      </Filler.SVGFiller>
    </Center>
  );
};
